import type { FormMode } from '@presentation/types';
import type { MouseEventHandler, ReactNode } from 'react';

export interface MtAnimalBuyerPageData {
  mode: FormMode;
  onEditClick?: MouseEventHandler;
  onDeleteClick?: MouseEventHandler;
  onBackClick?: MouseEventHandler;
  onUnarchiveClick?: MouseEventHandler;
  formComponent: ReactNode;
  archived?: boolean;
  loading?: boolean;
}

export interface MtAnimalBuyerPageProps extends MtAnimalBuyerPageData {}
